<!--
 * @Description:
 * @Author: xz
 * @Date: 2023-06-16 14:08:25
 * @LastEditTime: 2023-06-21 10:52:50
 * @LastEditors: xz
-->
<template>
    <div id="linChart" style="height: 400px; width: 600px;"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
    props : {
        className: {
            type: String,
            default: 'chart'
        },
        width: {
            type: String,
            default: '100%'
        },
        height: {
            type: String,
            default: '100%'
        },
        intiData: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            option : {
              title: {
                // text: 'Stacked Line'
              },
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: []
                // data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              toolbox: {
                feature: {
                  // saveAsImage: {}
                }
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: []
                // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
              },
              yAxis: {
                type: 'value'
              },
              series: [
              ]
            },
            chart:null
        };
    },
    watch: {
        $props: {
            handler(val, oldvalue) {
                // console.log("val",val,"oldvalue",oldvalue)
                if (this.chart) {
                    this.chart.dispose();
                }
                this.$nextTick(()=>{
                    this.initChart();
                })
            },
            deep: true,
        },
    },
    mounted() {
        this.initChart();
    },
    methods:{
        // clear(){
        //     let myChart=echarts.init(document.getElementById("linChart"));
        //     this.option.legend.data=[]
        //     this.option.series=[]
        //     this.option.xAxis.data=[]
        //     myChart.setOption(this.option);
        // },
        initChart() {
            console.log(this.option,"old");
            this.chart=echarts.init(document.getElementById("linChart"));
            let dataInti = this.$props.intiData;
            if(dataInti==null||dataInti.length==0||dataInti==[]){
                this.chart.clear()
                return
            }
            let dataList = [];
            let keys = []
            if(dataInti!=null&&dataInti!=[]) keys = Object.keys(dataInti[0])
            keys.forEach(key=>{
                let data = []
                dataInti.forEach(row=>{
                    data.push(row[key])
                })
                dataList.push({name:key,data:data})
            })
            // let dataList = [
            //     {name:"日期",data:["周一","周二","周三"],},
            //     {name:"温度",data:["11","12","13"],},
            //     {name:"湿度",data:["1","2","3"],},
            // ];
            let legendData = []
            let xAxisData = []
            let optionSeries = []
            for(let i=0;i<dataList.length;i++){
                if(i==0){
                    xAxisData=dataList[i].data
                }else{
                    legendData.push(dataList[i].name)
                    optionSeries.push({
                      name: dataList[i].name,
                      type: 'line',
                      data: dataList[i].data
                    })
                }
            }
            this.option.legend.data=legendData
            this.option.series=optionSeries
            this.option.xAxis.data=xAxisData
            console.log(this.option,"new");
            this.chart.setOption(this.option);
        },
    }
};
</script>
<style scoped>
</style>
  


// WEBPACK FOOTER //
// src/components/dataSource/chart/line.vue